import { Injectable } from '@angular/core';

import { AppStore } from '../stores/app.store';
import { environment } from '../../environments/environment';

@Injectable()
export class RouteResolverService {

  constructor(private store: AppStore) {

  }

  getParamByName(name) {
    const url = window.location.href;
    const paramName = name.replace(/[\[\]]/g, '\\$&');
    const regex = new RegExp('[?&]' + paramName + '(=([^&#]*)|&|#|$)'),
                    results = regex.exec(url);
    if (!results) {
      return null;
    }
    if (!results[2]) {
      return '';
    }
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }

  load(): Promise<any> {
    this.store.eventId = this.getParamByName('eventId');
    this.store.appId = this.getParamByName('appId');
    this.store.companyId = this.getParamByName('companyId');
    this.store.companyToken = this.getParamByName('companyToken');
    this.store.quickCode = this.getParamByName('quickCode');
    // "autoRotation" URL parameter represents the auto-rotation interval in milliseconds
    if (parseInt(this.getParamByName('autoRotation'), 10) > 0) {
      this.store.autoRotationInterval = parseInt(this.getParamByName('autoRotation'), 10);
    }
    // "onDemand" URL parameter defines the presentation mode of the posters.
    // Possible values in URL: 0 and 1
    // Defaults to what is set in the environment variables.
    this.store.isOnDemand = this.getParamByName('onDemand') ?
                            !!parseInt(this.getParamByName('onDemand'), 10) :
                            environment.posters.isOnDemand;
    // "id" URL parameter points to the selected poster with a specific
    // Abstract ID when "onDemand" mode
    this.store.posterId = this.getParamByName('id');
    // "category" URL parameter points to the category of the posters the app fetches.
    // Default category is "all".
    this.store.category = this.getParamByName('category');
    // "track" URL parameter points to the track of the posters the app fetches.
    // Default track is "all".
    this.store.track = this.getParamByName('track');
    // "monitor" URL parameter points to the monitor of the posters the app fetches.
    // Default monitor is "all".
    this.store.monitor = this.getParamByName('monitor');
    // "day" URL parameter points to the presentation day of the posters the app fetches.
    // Default day is "all".
    this.store.day = this.getParamByName('day');
    // "navigation" URL parameter for enabling/disabling the navigation between the posters.
    // Possible values in URL: 0 and 1
    // Defaults to what is set in the environment variables.
    this.store.navigationDisabled = this.getParamByName('navigation') ?
                            !(!!parseInt(this.getParamByName('navigation'), 10)) :
                            environment.posters.navigationDisabled;
    // "debug" URL parameter for enabling/disabling the debug mode.
    // If enabled the posters that are not submitted are displayed
    // along with the submitted ones.
    // Possible values in URL: 0 and 1
    // Defaults to what is set in the environment variables.
    this.store.isDebug = this.getParamByName('debug') ?
                            !!parseInt(this.getParamByName('debug'), 10) :
                            environment.posters.isDebug;
    // "prefix" URL parameter points to the prefix of the Event
    // which the posters will be fetched from.
    // Defaults to what is set in the environment variables.
    const prefix = this.getParamByName('prefix') || environment.posters.prefix;
    this.store.baseURL = environment.posters.baseURL + prefix + environment.posters.basePath;
    return Promise.resolve();
  }
}
